import { useEffect } from "react"
import useAppStore from "store/app"

import { Box } from "@mui/material"
import Layout from "./Layout"
import Navigation from "./Navigation"

import HealthStatus from "components/containers/HealthStatus"
import News from "components/containers/News"

const Home = () => {
  const getClientProfile = useAppStore((state) => state.getClientProfile)
  const syncFields = useAppStore((state) => state.syncFields)
  const syncClient = useAppStore((state) => state.syncClient)
  const resetAnamnesis = useAppStore((state) => state.resetAnamnesis)
  const resetFields = useAppStore((state) => state.resetFields)

  useEffect(() => {
    resetAnamnesis()
    resetFields()

    getClientProfile().then((response) => {
      syncClient(response.data)
      syncFields(response.data)
    })
  }, [])

  return (
    <Layout>
      <Box
        sx={{
          backgroundColor: "bg.main",
          px: 4,
          pb: 8,
          mx: -2.5,
          mt: -2,
        }}
      >
        <HealthStatus />
      </Box>

      <Box
        sx={{
          backgroundColor: "bg.light",
          p: 4,
          display: "flex",
          flexDirection: "column",
          borderTopRightRadius: 30,
          borderTopLeftRadius: 30,
          mt: -4,
          mx: -2.5,
          mb: 10,
        }}
      >
        <News />
      </Box>

      <Navigation />
    </Layout>
  )
}

export default Home
